import { useState } from 'react';
import Modal from '../ui/Modal';
import Textarea from '../ui/Textarea';
import Button from '../ui/Button';

export default function RejectDialog({ open, onClose, onConfirm, loading, actionLabel, closesRecruitment }) {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title={actionLabel}
      footer={
        <>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => onConfirm(reason)} loading={loading} disabled={!reason.trim()}>
            {actionLabel}
          </Button>
        </>
      }
    >
      {closesRecruitment && (
        <p className="mb-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">
          This will close the candidate's recruitment and mark them Rejected.
        </p>
      )}
      <Textarea label="Reason" required value={reason} onChange={(e) => setReason(e.target.value)} />
    </Modal>
  );
}
